export const IS_SANDBOX = process.env.REACT_APP_SANDBOX;
export const EXTENSION_IDENTIFIER = process.env.REACT_APP_EXTENSION_IDENTIFIER;
export const ZOHO_CONN_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__zoho";
export const DATA_CENTER_URL_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center_URL";
export const ORG_ID_API_NAME =
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Organization_ID";
export const API_KEYS = [
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__API_KEY",
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Organization_ID",
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__ZAPI_Key",
  process.env.REACT_APP_EXTENSION_IDENTIFIER + "__Data_Center_URL",
];
